import { FC } from "react";

interface AlarmIconSVGProps {
    className?: string;
}

const AlarmIconSVG: FC<AlarmIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.5835 2.41602H13.4168M11.5002 13.916L14.3752 11.041M19.1668 13.916C19.1668 18.1502 15.7343 21.5827 11.5002 21.5827C7.26598 21.5827 3.8335 18.1502 3.8335 13.916C3.8335 9.68183 7.26598 6.24935 11.5002 6.24935C15.7343 6.24935 19.1668 9.68183 19.1668 13.916Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AlarmIconSVG;
